/**
 * Represents a type of electricity tariff used for energy prices in project.
 */
export enum ElectricityTariff {
    NoSpecialTariff = 'NO_SPECIAL_TARIFF',
    DayNightTariff = 'DAY_NIGHT_TARIFF',
    LockPeriodTariff = 'LOCK_PERIOD_TARIFF'
}
